"use client";

export default function QuizErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="h-screen flex flex-col items-center justify-center bg-white">
      <h2 className="text-lg font-semibold mb-2">Quiz error</h2>
      <p className="text-sm text-gray-500 mb-4">Failed to load a quiz record.</p>
      <button
        onClick={reset}
        className="px-4 py-2 bg-blue-600 text-white rounded text-sm hover:bg-blue-700"
      >
        Retry
      </button>
    </div>
  );
}
